<template>
  <section
    v-if="item.length > 0"
    class="module dt-like"
  >
    <h3>{{ hobby_title }}</h3>
    <template v-for="(value, index) in item">
      <ul
        :key="index"
        class="dt-detail-like-list"
      >
        <li
          v-for="(v, i) in truncate(value)"
          :key="i"
        >
          <a
            :href="v.url"
            :uigs="'tiny_out_hobby_' + (index * 9 + i) + '_p'"
            :title="v.name"
          >
            <div class="dt-detail-like-img">
              <div :class="[spver === 1 ? 'default-film' : 'default-sogou']">
                <img
                  v-if="isSpider"
                  :src="checkHttps(v.v_picurl)"
                  :alt="v.name + '剧照'"
                >
                <img
                  v-else
                  v-lazy="checkHttps(v.v_picurl)"
                  :alt="v.name + '剧照'"
                >
              </div>
              <span class="tag-mark">{{ v.score }}</span>
            </div>
            <p class="dt-like-name">{{ v.name }}</p>
          </a>
        </li>
      </ul>
    </template>
  </section>
</template>

<script>
import { mapState } from 'vuex';

const { getSpver, checkHttpsUrl } = require('../../common/js/util');

export default {
  name: 'Like',
  data() {
    return {
      loadExtAdv: false,
      ad_io: null,
      addSogouJsInFs: false,
    };
  },
  computed: {
    ...mapState('detail', ['itemData']),
    item() {
      const items = this.itemData.hobby_item;
      const newArray = [];
      if (items && items.length > 0) {
        let index = 0;
        const sublength = 9;
        while (index < items.length) {
          newArray.push(items.slice(index, (index += sublength)));
        }
      }
      return newArray;
    },
    hobby_title() {
      return this.itemData.hobby_title;
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || 0;
    },
    isSpider() {
      return this.itemData.isSpiderUA;
    },
  },
  methods: {
    truncate(arr) {
      // 最后一行若是文字且少于3个则不展示
      const leng = arr.length;
      if (leng % 3 === 0) {
        return arr;
      }
      const n = Math.floor(leng / 3);
      return arr.slice(0, 3 * n);
    },
    checkHttps(url) {
      return checkHttpsUrl(url);
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.dt-detail-like-list {
  font-size: 0;
  padding: 0 14px;

  li {
    display: inline-block;
    width: 32%;
    margin-right: 2%;
    vertical-align: text-top;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  a {
    display: block;
  }
}
.dt-detail-like-img {
  width: 100%;
  padding-top: 140%;
  border-radius: 5px;
  overflow: hidden;
  position: relative;

  &:after {
    content: '';
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > span {
    position: absolute;
    display: block;
  }

  .tag-mark {
    right: 8px;
    bottom: 10px;
    color: #fece32;
    font-size: 13px;
    z-index: 2;
    font-weight: bold;

    &:first-letter {
      font-size: 19px;
    }
  }
}

.default-sogou {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('detail/sogou');
    z-index: -1;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}

.default-film {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('detail/film');
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}

.dt-like-img-playlist {
  width: 100%;
  padding-top: 116%;
  border-radius: 5px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
  }

  .img-one {
    position: absolute;
    width: 73%;
    height: 100%;
    border-radius: 5px;
    left: 0;
    top: 0;
    z-index: 3;
    overflow: hidden;
  }

  .img-two {
    position: absolute;
    width: 73%;
    height: 95%;
    border-radius: 5px;
    left: 16px;
    bottom: 0;
    z-index: 2;
    overflow: hidden;

    &:after {
      content: '';
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      opacity: 0.25;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .img-three {
    position: absolute;
    width: 73%;
    height: 88%;
    border-radius: 5px;
    left: 30px;
    bottom: 0;
    z-index: 1;
    overflow: hidden;

    &:after {
      content: '';
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      opacity: 0.6;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .tag-playlist {
    height: 18px;
    line-height: 18px;
    background: #fff;
    position: absolute;
    right: 0;
    bottom: 10px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    font-size: 11px;
    color: #222;
    z-index: 3;
    padding: 0 5px;
    font-weight: bold;
  }
}

.dt-like-name {
  @include line-clip(2);
  line-height: 21px;
  font-size: 15px;
  color: #000;
  margin: 6px 0 22px;
  display: -webkit-box;
}

.dt-like-tags {
  padding: 0 14px;
  font-size: 0;
  margin-bottom: 15px;

  li {
    display: inline-block;
    width: 32%;
    margin-right: 2%;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  a {
    @include line-clip(1);
    display: block;
    height: 35px;
    line-height: 35px;
    border-radius: 5px;
    background: #f5f5f5;
    text-align: center;
    font-size: 13px;
    color: #222;
    padding: 0 10px;
    margin-bottom: 10px;
  }
}

.dt-like-ad {
  margin: 0 14px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  height: 192px;
  margin-bottom: 27px;

  &.small {
    height: 45px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: bottom;
  }

  p {
    width: 100%;
    height: 32px;
    line-height: 32px;
    @include line-clip(1);
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    text-indent: 10px;
    font-size: 15px;
  }

  button {
    border: none;
    width: 28px;
    height: 28px;
    position: absolute;
    right: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);

    &:before {
      content: '';
      width: 1px;
      height: 14px;
      background: #fff;
      transform: rotate(45deg);
      @extend %-absolute-center;
    }

    &:after {
      content: '';
      width: 1px;
      height: 14px;
      background: #fff;
      transform: rotate(-45deg);
      @extend %-absolute-center;
    }
  }
}
</style>
